export default __webpack_public_path__ + "static/media/what-is-ethereum.4a827a1c.webp";